export function GetItem(selectedItem, setSelectedItem, Get, id) {

    Get(id)
        .then((data) => {
            setSelectedItem(data)
            //console.log(selectedItem)
        })
        .catch(err => {
            //console.log(err.response)
        })

}